<script setup lang="ts">
import { type PropType, computed } from 'vue'
import { isMobile } from '@/legacy/ts/checkDevice'

export interface ICampaignCard {
	title: string
	tracking: string
	webImage: string
	appImage: string
	url: string
}

const props = defineProps({
	blog: {
		type: Object as PropType<ICampaignCard>,
		default: () => ({}),
	},
	isDataLoaded: {
		type: Boolean,
		default: false,
	},
	pageContent: {
		type: Object as PropType<{ [key: string]: string }>,
		required: true,
	},
})

const hoverClasses = computed(() => {
	if (props.isDataLoaded) {
		return 'hover:border-n-950 hover:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)]'
	}
	return ''
})

const showBlog = computed(() => {
	return (
		!props.isDataLoaded || (props.blog && Object.keys(props.blog).length > 0)
	)
})

function onClickItem(event: MouseEvent) {
	window.open(props.blog.url, '_self')
}
</script>

<template>
	<div
		v-if="showBlog"
		class="flex flex-col rounded-rwd-lg border border-n-100 bg-white"
		:class="hoverClasses"
	>
		<div class="cursor-pointer" :href="blog.url" @click="onClickItem">
			<div class="aspect-video w-full">
				<img
					:src="isMobile ? blog.appImage : blog.webImage"
					:alt="`image of '${blog.title}'`"
					loading="lazy"
					class="w-full rounded-t-lg object-cover"
				/>
			</div>
			<div class="p-close-friends">
				<h2 class="typography-s1-emp line-clamp-2 text-ellipsis text-n-950">
					{{ blog.title }}
				</h2>
			</div>
		</div>
	</div>
</template>
